import { isEmpty } from "lodash"

export const removeToken = () => {
  localStorage.removeItem('token')
}

export const setToken = token => {
  localStorage.setItem('token', token)
}

export const getToken = () => {
  const token = localStorage.getItem('token')
  return token
}
export const checkToken = () => {
  const token = localStorage.getItem('token')
  return !isEmpty(token)
}
